export default "__VITE_ASSET__460ef264__"